module.exports = __webpack_public_path__ + "img/alertsmall.3334e486.svg";